import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import mediLogo from "../../assets/images/logo.png";
import "./Game.css";
import QuizContainer from "./arrange/QuizContainer";
import QuizContainerMcq from "./Mcq/QuizContainer";
import MobileDesign from "./MobileDesign";
import { useParams } from "react-router-dom";
import { IoReorderThree } from "react-icons/io5";
import { FaRegQuestionCircle } from "react-icons/fa";
import mcqLogo from "../../assets/images/mcqLogo.png";
import puzzleLogo from "../../assets/images/puzzleLogo.png";
import Seo from "../../Components/Seo";

export default function Game() {
  const { type } = useParams();
  const [isStarted, setStart] = useState(false); // start test
  const [isActive, setIsActive] = useState(false); // is timer active
  const [isFinished, setIsFinished] = useState(false); // finished test
  const [seconds, setSeconds] = useState(160); // timer
  const [optionToggle, setOptionToggle] = useState(0);

  const [isStartedMcq, setStartMcq] = useState(false); // start test 2
  const [isActiveMcq, setIsActiveMcq] = useState(false); // is timer active 2
  const [isFinishedMcq, setIsFinishedMcq] = useState(false); // finished test 2
  const [secondsMcq, setSecondsMcq] = useState(160); // timer 2
  const [viewPort, setViewPort] = useState(window.innerWidth); // view port
  const compliments = [
    "Amazing",
    "Awesome",
    "Great",
    "Excellent",
    "Fantastic",
    "Wonderful",
    "Superb",
    "Terrific",
    "Outstanding",
    "Marvelous",
  ];
  useEffect(() => {
    let interval = null;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    if (!isActive && seconds < 0) {
      clearInterval(interval);
    }
    if (seconds < 1) {
      setIsFinished(true);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]); // timer

  useEffect(() => {
    let interval2 = null;

    if (isActiveMcq && secondsMcq > 0) {
      interval2 = setInterval(() => {
        setSecondsMcq((prev) => prev - 1);
      }, 1000);
    }

    if (!isActiveMcq && secondsMcq < 0) {
      clearInterval(interval2);
    }
    if (secondsMcq < 1) {
      setIsFinishedMcq(true);
    }

    return () => clearInterval(interval2);
  }, [isActiveMcq, secondsMcq]); // timer 2

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const options = [
    {
      id: 1,
      logo: puzzleLogo,
      title: "The Puzzle Game",
      icon: <IoReorderThree />,
      desc: "  Test your knowledge by arranging medical concepts in the correct sequence.",
      features: [
        "Sequential learning",
        "Process Understanding",
        "Critical Thinking",
      ],
      link: "/arrange",
    },
    {
      id: 2,
      logo: mcqLogo,
      title: "Multiple Choice Questions",
      icon: <FaRegQuestionCircle />,
      desc: "Challenge yourself with comprehensive MCQs covering various  medical topics.",
      features: ["Quick Assessment", "Broad Coverage", "Instant Feedback"],
      link: "/mcq",
    },
  ];
  useEffect(() => {
    const handleResize = () => {
      setViewPort(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className=" p-3 text-center d-flex justify-content-center flex-column align-items-center gap-5"
      style={{
        marginTop: "7rem",
      }}
    >
      {!type && (
        <div
          className="d-flex flex-column align-items-center"
          style={{ marginBlock: "50px", color: "gray" }}
        >
          {" "}
          <Seo
            description={`Enhance your medical knowledge through interactive games designed
            for healthcare professionals and students. Choose from our
            collection of educational medical simulations.`}
            title={"Medical Games"}
          />
          <h1 className="">Choose your learning adventure.</h1>
          <h5
            style={{
              paddingInline: `${viewPort <= 768 ? "0%" : "20%"}`,
            }}
          >
            Enhance your medical knowledge through interactive games designed
            for healthcare professionals and students. Choose from our
            collection of educational medical simulations.
          </h5>
          <div
            style={{
              marginBlock: "100px",
              display: "flex",
              flexDirection: `${viewPort <= 768 ? "column" : "row"}`,
            }}
            className="  vh-100  position-relative   justify-content-center  gap-5  w-100 "
          >
            {options?.map((item) => (
              <div
                onMouseEnter={() => setOptionToggle(item?.id)}
                onMouseLeave={() => setOptionToggle(0)}
                key={item?.id}
                style={{
                  width: `${viewPort <= 768 ? "100%" : "25%"}`,
                  height: "fit-content",
                  transition: "all",
                  transitionDuration: "300ms",

                  transform:
                    optionToggle === item?.id ? "translate(0px, -20px)" : "",
                }}
                className={`  text-left d-flex  gap-3 flex-column  justify-content-between pb-3  overflow-hidden  border-2 border   rounded-3`}
              >
                <div
                  style={{
                    height: viewPort > 768 ? "30vh" : "20vh",
                    background:
                      item?.id === 1
                        ? "linear-gradient(150deg,#42ed81, #42ed81)"
                        : "linear-gradient(45deg,#34A9DF, #5494E0)",
                  }}
                  className="  w-auto d-flex justify-content-center align-items-center"
                >
                  <img
                    src={item?.logo}
                    className="  h-100 object-fit-cover  "
                    alt=""
                    style={{
                      height: "100%",
                    }}
                  />
                </div>
                <div className="">
                  <h5 className="d-flex px-3 text-nowrap gap-2">
                    <span
                      className="text-white h rounded-circle px-1"
                      style={{
                        background: `${
                          item?.id === 2 ? "#007bff" : "rgb(36, 205, 75)"
                        }`,
                        height: "fit-content",
                      }}
                    >
                      {item?.icon}
                    </span>
                    {item?.title}{" "}
                  </h5>
                  <p
                    className="px-3"
                    style={{
                      color: "gray",
                    }}
                  >
                    {item?.desc}
                  </p>
                </div>

                <button
                  className={`rounded-3  text-white  text-center fs-5 p-2 border-0 w-75 mx-auto `}
                  onClick={() => (window.location.href = `/games${item?.link}`)}
                  style={{
                    background:
                      item?.id === 1
                        ? "linear-gradient(3deg,#40d175, #40d175)"
                        : "linear-gradient(45deg,#34A9DF, #5494E0)",
                  }}
                >
                  Play Now{" "}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
      {type === "arrange" && (
        <div className=" d-flex   justify-content-center align-items-center flex-column w-100">
          <Seo
            description={`Puzzle game is a kind of drag and drop type select response
                  game that presents a question and the user tries to rearrange
                  the pieces of the puzzle.`}
            title={"Puzzle Game"}
            link={puzzleLogo}
          />
          <MobileDesign
            setIsActive={setIsActive}
            setStart={setStart}
            setSeconds={setSeconds}
          >
            {isStarted ? (
              <QuizContainer
                isFinished={isFinished}
                compliments={compliments}
                setStart={setStart}
                formatTime={formatTime}
                setIsActive={setIsActive}
                setIsFinished={setIsFinished}
                isActive={isActive}
                setSeconds={setSeconds}
                seconds={seconds}
                isStarted={isStarted}
              />
            ) : (
              <div
                className="w-100 d-flex flex-column justify-content-around    rounded-2"
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "60%",
                    width: "100%",
                  }}
                  className=" d-flex gap-2 flex-column"
                >
                  <img
                    src={mediLogo}
                    alt=""
                    style={{
                      objectFit: "contain",
                      height: "15%",
                      width: "100%",
                    }}
                  />
                  <img
                    src={puzzleLogo}
                    style={{
                      objectFit: "contain",
                      height: "70%",
                      width: "100%",
                    }}
                    className="mt-5"
                    alt=""
                  />
                  <h5> The Puzzle Game</h5>{" "}
                </div>
                <button
                  className="bg-info text-white mx-auto  rounded-3 p-2 border-0"
                  style={{
                    cursor: "pointer",
                    width: "fit-content",
                  }}
                  onClick={() => {
                    setStart(true);
                    setIsActive(true);
                    setSeconds(160);
                  }}
                >
                  Let the game begin {"->"}
                </button>
              </div>
            )}
          </MobileDesign>
        </div>
      )}
      {type === "mcq" && (
        <div className=" d-flex mt-4 justify-content-center align-items-center flex-column w-100">
          <Seo
            description={`   MCQ is a kind of select response game. The module displays
                  around 4 multiple options and you choose the best answer from
                  the list.`}
            title={"MCQ Game"}
            link={mcqLogo}
          />
          <MobileDesign
            setIsActive={setIsActiveMcq}
            setStart={setStartMcq}
            setSeconds={setSecondsMcq}
          >
            {isStartedMcq ? (
              <div
                className="w-100  bg-light rounded-2"
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <QuizContainerMcq
                  compliments={compliments}
                  isFinished={isFinishedMcq}
                  setStart={setStartMcq}
                  formatTime={formatTime}
                  setIsActive={setIsActiveMcq}
                  setIsFinished={setIsFinishedMcq}
                  isActive={isActiveMcq}
                  setSeconds={setSecondsMcq}
                  seconds={secondsMcq}
                  isStarted={isStartedMcq}
                />
              </div>
            ) : (
              <div
                className="w-100 d-flex flex-column justify-content-around    rounded-2"
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "60%",
                    width: "100%",
                  }}
                  className=" d-flex gap-2 flex-column"
                >
                  <img
                    src={mediLogo}
                    alt=""
                    style={{
                      objectFit: "contain",
                      height: "20%",
                      width: "100%",
                    }}
                  />
                  <img
                    src={mcqLogo}
                    className="
                    mt-3"
                    style={{
                      objectFit: "contain",
                      height: "70%",
                      width: "100%",
                    }}
                    alt=""
                  />
                  <h4> Multiple choice questions</h4>{" "}
                </div>
                <button
                  className="bg-info text-white mx-auto  rounded-3 p-2 border-0"
                  style={{ cursor: "pointer", width: "fit-content" }}
                  onClick={() => {
                    setStartMcq(true);
                    setIsActiveMcq(true);
                    setSecondsMcq(160);
                  }}
                >
                  Let the game begin {"->"}
                </button>
              </div>
            )}
          </MobileDesign>
        </div>
      )}
    </div>
  );
}
